import { render, staticRenderFns } from "./BlockSubscribers.vue?vue&type=template&id=df581e90&"
import script from "./BlockSubscribers.vue?vue&type=script&lang=ts&"
export * from "./BlockSubscribers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports